import { render } from "./IncomeProtectionCommissionSetting.vue?vue&type=template&id=ea0b637a&scoped=true"
import script from "./IncomeProtectionCommissionSetting.vue?vue&type=script&lang=js"
export * from "./IncomeProtectionCommissionSetting.vue?vue&type=script&lang=js"

import "./IncomeProtectionCommissionSetting.vue?vue&type=style&index=0&id=ea0b637a&lang=css"
import "./IncomeProtectionCommissionSetting.vue?vue&type=style&index=1&id=ea0b637a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea0b637a"]])

export default __exports__